import { useEffect, useState } from 'react';
import './Navigation.scss';
import Collapse from '../Collapse/Collapse';
import { Link } from 'react-router-dom';
import { useData } from '../../context/programsContext';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { useAuth } from '../../context/AuthProvider';
import DropdownMenu from './DropdownMenu';
import Logo from '../Logo/Logo'
import Hamburger from '../../assets/icons/Hamburger';

function Navigation() {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isServicesOpen, setServicesOpen] = useState(false);
    const [isAtTop, setIsAtTop] = useState(true);
    const { user, loading } = useAuth();
    
    useEffect(() => { 
        window.addEventListener('scroll', handleScroll); 
        return () => { 
            window.removeEventListener('scroll', handleScroll); 
        }; 
    });

    const services = [
        {
            title: "Neurowellness",
            href: "https://neuro-research.ai/neurowellness/en"
        },
        {
            title: "Content Neurofeedback",
            href: "https://neuro-research.ai/neurowellness/en"
        },
        {
            title: "Research",
            href: "https://neuro-research.ai/neurowellness/en"
        },
        {
            title: "Software and Web Development",
            href: "https://neuro-research.ai/neurowellness/en"
        },
        {
            title: "Events",
            href: "https://neuro-research.ai/events/en"
        }
    ];

    const programs = useData().data;

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    }

    const toggleServices = () => {
        setServicesOpen(!isServicesOpen);
    }

    const handleScroll = () => { 
        const isTop = window.scrollY === 0;
        setIsAtTop(isTop);
    }; 


  return (
    <header id='navigation' className={(isAtTop ? "" : "collapsed")}>
        <div className='rainbow'>
            <div className='content'>
                <nav className='programs'>
                    {
                        programs.map(p => 
                            p.isDisabled || p.id === "your-program" ? null 
                            : (
                                <Link className='program' id={p.id} key={p.id} to={`products/${p.id}`}>
                                    {p.card.icon}<span className='title full'>{p.card.title}</span>
                                </Link>
                            )
                        )
                    }
                </nav>
                <div className='actions'>
                    <LanguageSwitcher/>
                    {loading ? (
                        <button className='btn primary small' disabled></button>
                    ) : user ? 
                    (
                        <DropdownMenu/>
                    )
                     : (
                        <Link to={'/user/signin'}>
                            <button className='btn primary small'>SignIn</button>
                        </Link>
                    )}
                    
                </div>
            </div>
        </div>
        <div id='menu' className={(isAtTop ? "" : "collapsed")}>
            <button className={"menu_item tab " + (isServicesOpen ? "" : "collapsed")} onClick={toggleServices}>Services</button>
            <Link className='menu_item' to={'/products'}>Products</Link>
            <Logo/>
            <a className='menu_item' href='https://neuro-research.ai/quantum/en#team'>About Us</a>
            <a className='menu_item' href='https://neuro-research.ai/contact-us/en'>Contacts</a>
            <button onClick={toggleMobileMenu} style={{aspectRatio: 1, width: '2rem'}}><Hamburger/></button>
        </div>
        <div className={'submenu ' + (isServicesOpen ? "" : "hidden ") + (isAtTop ? "" : "collapsed")}>
            {services.map((item, index) => (
                    <a className='menu_item' href={item.href} key={index}>{item.title}</a>
                ))}
        </div>
        <div id='menuMobile' className={isMobileMenuOpen ? "" : "hidden"} onClick={(e) => e.preventDefault()}>
            <div className='content'>
                <nav>
                    <Collapse head="Services" list={services}/>
                    <Link className='menu_item' to={'/products'}>Products</Link>
                    <a className='menu_item' href='https://neuro-research.ai/quantum/en#team'>About</a>
                    <a className='menu_item' href='https://neuro-research.ai/contact-us/en'>Contacts</a>
                </nav>
                <button className='btn close' onClick={toggleMobileMenu}></button>
            </div>
        </div>
    </header>
  )
}

export default Navigation